export default __webpack_public_path__ + "static/media/gwn29.5ad70bfb.webp";